import configureOrigin from './lib/configure-origin';

export default {
  __init__: [
    configureOrigin
  ]
};